import { str } from '../lib/str.js'
import { UI } from '../lib/ui.js'

export class Toast {
    constructor(){
        const ui = window.ui ? window.ui : new UI
        
        this.wrapper = ui.element('toasts',false) ? ui.element('toasts') 
        :  ui.element('div',{id:'toasts',class:'toast-container',style:'position:fixed;bottom:0;right:0;padding:1rem;z-index:1002;'})
        if(!ui.element('toasts',false))
            ui.body.append(this.wrapper)
        this.toast
        this.options
        this.convertToasts()
    }
    /**
     * 
     * @param {*} title 
     * @param {*} message 
     */
     show(options){
        if(options.id && ui.element(options.id,false))
            return
        const toast = ui.element('div',{class:'toast show',role:'alert','aria-live':'assertive','aria-atomic': true}),
              header = ui.element('div', {class: 'toast-header'},options.title),
              body = ui.element('div', {class: 'toast-body'}), 
              message = ui.element('span',{class : 'toast-message grey'}),
              close = ui.element('button',{type:'button',class:'btn-close float-end','data-dismiss':'toast','aria-label':'Close'})
        this.toast = toast
        this.options = options
        if(!options.remove)
            options.remove = 6000
        if(options.id)
            toast.setAttribute('id',options.id)
        else
            toast.setAttribute('id',str.getRandom(32))
        if(str.isHTML(options.message))
            message.innerHTML = options.message
        else
            message.textContent = options.message
        body.append(message)
        body.append(close)
            
        if(options.type){
            toast.classList.add(options.type)
            switch (options.type) {
                case 'error':
                    toast.classList.add('text-danger')
                    break;
                case 'info':
                default:
                    toast.classList.add('text-info')
                    break;
            }
        }
        if(options.icon){
            if(options.title){
                header.prepend(ui.icon(options.icon))
            }else{
                body.prepend(ui.icon(options.icon))
            }
        }
        if(options.title)
            toast.append(header)
        toast.append(body)
        
        close.addEventListener('click',()=> this.remove())
        if(options.remove)
            setTimeout(()=>{
                this.remove(toast)
            },options.remove)
        this.wrapper.prepend(toast)
    }
    /**
     * Remove the toast from the DOM
     */
    remove(){
        if(this.toast){
            this.toast.classList.add('fade')
            this.toast.classList.remove('show')
            setTimeout(()=>{
                this.toast.remove()
            },1)
        }
    }
    /**
     * Converts all elements with data-toast attribute to toasts
     */
    convertToasts(){
        ui.select(':[data-toast]').forEach( element => {
            let type
            if(element.classList.contains('bg-danger'))
                type = 'error'
            else
                type = 'info'
            element.remove()
            this.show({
                message : element.textContent,
                type : type

            })
        })
    }
}